import { render, staticRenderFns } from "./RemediationSummary.vue?vue&type=template&id=54c35534&scoped=true"
import script from "./RemediationSummary.vue?vue&type=script&lang=js"
export * from "./RemediationSummary.vue?vue&type=script&lang=js"
import style0 from "./RemediationSummary.vue?vue&type=style&index=0&id=54c35534&prod&scoped=true&lang=css"
import style1 from "./RemediationSummary.vue?vue&type=style&index=1&id=54c35534&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c35534",
  null
  
)

export default component.exports